import { finish, error, clear } from '../../../modules/betslip/actions/reject-referred-betslip';

import api from '../../../api';

export function request(dispatch, { userId }) {
    api.post('/customers/' + userId + '/requested-betslip/reject', {}).then(
        () => {
            dispatch(finish(userId));

            setTimeout(() => {
                dispatch(clear(userId));
            }, 4000);
        },
        ({ errors }) => dispatch(error(userId, errors))
    );
}
